import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { getChart, setPalette } from '../../../core/chart';
import { getGenerations } from '../../../core/generations';
import { getPalettesVariations, setPaletteVariation } from '../../../core/palettes';

import { map, isEqual, reverse } from 'lodash';
import { _DisplayFlex } from '../../common/styled-flex';
import { 
  solidColor,
  doubleDarkChroma,
  creamyRings,
  colorRings,
  frosted,
  ombre,
  bananaSundaes,
  fiesta,
  banded,
  naturalLight,
} from '../../../core/palettes/options';
import { lowerCamelCaseToRegular } from '../../../core/utils';

import PreviewChart from '../../fanchart/preview';
import AutoScale from 'react-auto-scale';
import { StyledScrollable, StyledMargin } from '../../common/styled-base';
import { StyledPreview } from '../styled-sidebar';
import tinycolor from 'tinycolor2';

import PixelBar from './pixel-bar';

const StyledSmall = styled.small`
  font-size: 0.7em;
  font-weight: normal;
`;

const palettes = {
  solidColor,
  doubleDarkChroma,
  creamyRings,
  colorRings,
  frosted,
  ombre,
  bananaSundaes,
  fiesta,
  banded,
  naturalLight,
}


class PaletteMenu extends React.Component {

  render() {

    const { 
      chart, 
      generations, 
      setPalette, 
      palettesVariations,
      setPaletteVariation,
    } = this.props;

    const _palettes = map(palettes, (palette, key) => {
      const variation = palettesVariations[key] || palette.variations[0];
      return {
        key: key,
        name: lowerCamelCaseToRegular(key),
        variations: palette.variations.map(variation => (
          isEqual(variation, palettesVariations[key]) 
          ? {...variation, colors: reverse([...variation.colors])}
          : variation
        )),
        strokeWidth: variation.strokeWidth,
        strokeColor: variation.strokeColor,
        colors: palette.getColors(variation, chart.generations),
      }
    })

    return (
      <_DisplayFlex direction="column" flex="1">
        <StyledScrollable style={{maxHeight: 'calc(100vh - 55px)'}}>
          {_palettes.map((palette, i) => (
            <StyledPreview key={i}>
              <StyledMargin marginBottom="10px" onClick={() => setPalette(palette)}>
                <AutoScale>
                  <PreviewChart 
                    chart={{
                      angle: chart.angle,
                      angleOffset: chart.angleOffset,
                      generations: 7,
                      strokeWidth: palette.strokeWidth,
                      strokeColor: palette.strokeColor,
                    }}
                    generations={generations.slice(0, 7)}
                    palette={palette} />
                </AutoScale>
              </StyledMargin>
              <StyledMargin marginBottom="0">
                {palette.name}
              </StyledMargin>
              <StyledMargin marginBottom="10px">
                <small>(Click the chart above to update)</small>
              </StyledMargin>
              <PixelBar 
                pixels={map(palette.variations, 'colors')} 
                onClick={i => setPaletteVariation(palette.key, palette.variations[i])} 
                />
            </StyledPreview>
          ))}
        </StyledScrollable>
      </_DisplayFlex>
    )
  }
}

const mapStateToProps = createSelector(
  getChart,
  getGenerations,
  getPalettesVariations,
  (chart, generations, palettesVariations) => ({
    chart,
    generations,
    palettesVariations,
  })
)

const mapDispatchToProps = Object.assign({setPalette, setPaletteVariation});
export default connect(mapStateToProps, mapDispatchToProps)(PaletteMenu);


// WEBPACK FOOTER //
// ./src/components/menu/palette-menu/index.js